import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {catchError, map, Observable, of, shareReplay} from 'rxjs';
import {
  IExternalTravelServiceTypeOption,
  ITravelTypeOption,
} from '../interfaces/adx-erp-panel.interface';

@Injectable({
  providedIn: 'root'
})
export class AdxErpLookupService {
  private readonly http = inject(HttpClient);

  private travelTypes$?: Observable<ITravelTypeOption[]>;

  private externalTravelServiceTypes$?: Observable<IExternalTravelServiceTypeOption[]>;

  /** Cached list of active travel types used to populate the Travel Type filter dropdown. */
  public getTravelTypes(): Observable<ITravelTypeOption[]> {
    this.travelTypes$ ??= this.http.get<ITravelTypeOption[]>('dbov2/travel-type')
      .pipe(
        map(travelTypes => [...travelTypes]
          .sort((a, b) => (a.travelTypeName ?? '').localeCompare(b.travelTypeName ?? ''))),
        catchError(() => of<ITravelTypeOption[]>([])),
        shareReplay(1),
      );
    return this.travelTypes$;
  }

  /** Cached list of active external travel service types used to populate that filter dropdown. */
  public getExternalTravelServiceTypes(): Observable<IExternalTravelServiceTypeOption[]> {
    this.externalTravelServiceTypes$ ??= this.http
      .get<IExternalTravelServiceTypeOption[]>('dbov2/external-travel-service-type')
      .pipe(
        map(types => [...types].sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''))),
        catchError(() => of<IExternalTravelServiceTypeOption[]>([])),
        shareReplay(1),
      );
    return this.externalTravelServiceTypes$;
  }
}
